<div class="recorder_modal management-add-target">
  <p class="recorder_modal_title">Create Audit</p>

  <div style="display: flex; flex-direction: column; gap: 10px">
    <label class="custom-input_field_withoutIcon" style="width: 100%">
      <span class="custom-input_field-label"> Website URL </span>
      <input
        class="custom-input_field"
        matInput
        #name
        id="url"
        [(ngModel)]="url"
        type="text"
      />
    </label>
    <!-- <div class="custom_option_picker_with_absolute_label">
      <span class="custom_option_picker-label"> Max Steps </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select [(ngModel)]="max_steps">
            <mat-option *ngFor="let step of maxStepsOptions" [value]="step">
              {{ step }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->
    <!-- <div class="custom_option_picker_with_absolute_label">
      <span class="custom_option_picker-label"> Select Device </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select [(ngModel)]="selectedDevice">
            <mat-option value="desktop">Desktop</mat-option>
            <mat-option value="mobile">Mobile</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->
    <div class="custom_option_picker_with_absolute_label">
      <span class="custom_option_picker-label"> Region </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select [(ngModel)]="selectedCountry" placeholder="">
            <mat-option
              *ngFor="let l of suggestedCountries"
              [value]="l.name"
              [style.display]="hideCountriesMAP.includes(l.name) ? 'none' : ''"
            >
              {{ l.name }}
            </mat-option>
            <div
              class="sidenav-search-input"
              *ngIf="suggestedCountries && suggestedCountries?.length > 7"
            >
              <input
                placeholder="Search regions"
                (keydown.space)="$event.stopPropagation()"
                (keyup)="searchRegion($event)"
              />
            </div>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="custom_option_picker_with_absolute_label">
      <span class="custom_option_picker-label"> Language </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select [(ngModel)]="selectedLanguage" placeholder="">
            <mat-option *ngFor="let l of filteredLanguages" [value]="l.value">
              {{ l.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="custom_option_picker_with_absolute_label">
      <span class="custom_option_picker-label"> Audit Type </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select [(ngModel)]="auditType" placeholder="">
            <mat-option *ngFor="let l of auditTypes" [value]="l.value">
              {{ l.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="button_container" style="margin-top: 30px">
    <button mat-raised-button (click)="dialogRef.close()" class="seo_cancel">
      Cancel
    </button>
    <button
      mat-raised-button
      type="submit"
      class="primary"
      mat-button
      (click)="addTask()"
      [disabled]="isDisabled()"
    >
      {{ isAdding ? "Creating Audit" : "Create Audit" }}
    </button>
  </div>
</div>
